import {
    IconAdobeCC,
    IconArgo,
    IconAWS,
    IconConfluence,
    IconCypress,
    IconDocker,
    IconFigma,
    IconJavaScript,
    IconJest,
    IconJira,
    IconKotlin,
    IconKubernetes,
    IconNest,
    IconNext,
    IconNode,
    IconPostman,
    IconReact,
    IconSalesforce,
    IconSwift,
    IconTerraform,
    IconTypeScript,
} from '../icon';
import { Category, Tech } from './types';

export const CATEGORIES = [
    Category.Engineering,
    Category.Design,
    Category.Processes,
];

export const TECHNOLOGIES: Tech[] = [
    {
        category: Category.Engineering,
        icon: <IconJavaScript />,
        name: 'JavaScript',
    },
    {
        category: Category.Engineering,
        icon: <IconTypeScript />,
        name: 'TypeScript',
    },
    {
        category: Category.Engineering,
        icon: <IconAWS />,
        name: 'AWS',
    },
    {
        category: Category.Engineering,
        icon: <IconNest />,
        name: 'Nest.js',
    },
    {
        category: Category.Engineering,
        icon: <IconSwift />,
        name: 'Swift',
    },
    {
        category: Category.Engineering,
        icon: <IconKotlin />,
        name: 'Kotlin',
    },
    {
        category: Category.Engineering,
        icon: <IconCypress />,
        name: 'Cypress',
    },
    {
        category: Category.Engineering,
        icon: <IconDocker />,
        name: 'Docker',
    },
    {
        category: Category.Engineering,
        icon: <IconNode />,
        name: 'Node.js',
    },
    {
        category: Category.Engineering,
        icon: <IconReact />,
        name: 'React',
    },
    {
        category: Category.Engineering,
        icon: <IconJest />,
        name: 'Jest',
    },
    {
        category: Category.Engineering,
        icon: <IconKubernetes />,
        name: 'Kubernetes',
    },
    {
        category: Category.Engineering,
        icon: <IconNext />,
        name: 'Next.js',
    },
    {
        category: Category.Engineering,
        icon: <IconSalesforce />,
        name: 'Salesforce',
    },
    {
        category: Category.Engineering,
        icon: <IconTerraform />,
        name: 'Terraform',
    },
    {
        category: Category.Engineering,
        icon: <IconArgo />,
        name: 'Argo CD',
    },
    {
        category: Category.Engineering,
        icon: <IconPostman />,
        name: 'Postman',
    },
    {
        category: Category.Design,
        icon: <IconFigma />,
        name: 'Figma',
    },
    {
        category: Category.Design,
        icon: <IconAdobeCC />,
        name: 'Adobe Creative Cloud',
    },
    {
        category: Category.Processes,
        icon: <IconJira />,
        name: 'JIRA',
    },
    {
        category: Category.Processes,
        icon: <IconConfluence />,
        name: 'Confluence',
    },
];
